import React from "react";
import Skills from "./Skills/Skills";

const About = () => {
  return (
    <section className="py-8">
      <div className="flex flex-wrap md:px-4">
        <div className="w-full">
          <div className="md:mx-4">
            <h3 className="text-2xl text-gray-800 font-bold mb-4">Who am I?</h3>
            <p className="text-sm text-gray-400 leading-6 mb-3">
              I'm Ikram, a 1337 student passionate about coding and problem solving. Through the 42 School program, I've developed strong fundamentals in C, C++, JavaScript, and modern development practices. I love building projects, debugging complex problems, and collaborating with peers in peer led learning environments.
            </p>
            <p className="text-sm text-gray-400 leading-6 mb-3">
              My experience spans full stack development, algorithms, and data structures. I'm self motivated, always learning new technologies, and committed to writing clean, efficient code that solves real problems.
            </p>
          </div>
          <Skills />
        </div>
      </div>
    </section>
  );
};

export default About;
